import NextLink from 'next/link';
import { hasRetro } from 'lib/helpers';

import {
  Card,
  formatTimeAgo,
  Heading,
  Markdown,
  Rule,
} from '@frontendmentorio/design-system-v2';

import Flag from 'features/shared/Flag';
import Footer from './Footer';
import Tags from 'features/solutions/Tags';
import UserDetails from 'features/learners/UserDetails';

export default function SolutionCard({
  headingTag = 'h2',
  hideRetrospective,
  solution,
}) {
  const retrospective =
    !hideRetrospective &&
    hasRetro(solution) &&
    solution.retrospective?.assistance;

  return (
    <Card className="flex flex-col min-w-0" tagName="li">
      {solution.private && (
        <Card.Flags>
          <Flag type="private" />
        </Card.Flags>
      )}

      <Card.Image
        href={`/solutions/${solution.slug}`}
        src={solution.screenshot}
      />

      <div className="flex flex-col flex-grow gap-3 min-h-0 p-5">
        <NextLink
          className="hover:underline"
          href={`/solutions/${solution.slug}`}
        >
          <Heading level="5" tagName={headingTag}>
            {solution.title}
          </Heading>
        </NextLink>

        {solution.tags?.length > 0 && (
          <Tags className="text-sm" tags={solution.tags} />
        )}

        <Rule />

        <UserDetails usernameIsHidden user={solution.user}>
          <span className="not-italic">
            Submitted {formatTimeAgo(solution.submittedAt)}
          </span>
        </UserDetails>

        {retrospective && (
          // clamp the first child to 3 lines and hide the rest of the children
          <Markdown className="text-neutral-500 [&_*:first-child]:line-clamp-3 [&_*:not(:first-child)]:hidden">
            {retrospective}
          </Markdown>
        )}

        <Rule className="mt-auto" />

        <Footer solution={solution} />
      </div>
    </Card>
  );
}
